export default __webpack_public_path__ + "static/media/cover.dfa8b4f1.png";